import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Checkbox, Upload, Typography, Spin } from "antd";
import { LeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { APPLICATION_SUBMIT_SUCCESSFULLY, SUBMISSION_FAILED, FILE_SIZE_VALIDATION, FILE_TYPE_VALIDATION, COMMON_ERROR_MSG } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import CurrencyInput from "../../components/CurrencyInput";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import ApplicationProgressBar from "./ApplicationProgressBar";
import ButtonComponent from "../../components/Button/Button";
import IntegerInput from "../../components/IntergerInput";


const { Option } = Select;
const { Title, Text } = Typography;


const IncomeSources = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [IncomeSource, setIncomeSource] = useState({});
    const applicationId = localStorage.getItem("ApplicationId");
useEffect(() => {
  window.scrollTo(0, 0);
}, []);

    const location = useLocation();
    let data = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;

    if (data && data.applicationObjId) {
        applnObjId = data.applicationObjId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }
    if (data && data.activeKey) {
        activeKeyTab = data.activeKey;
    }

    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);


    useEffect(() => {
        GetIncomeSourceByApplicationID();
    }, []);

    useEffect(() => form.resetFields(), [IncomeSource]);

    // 🧠 Watch each income field separately
    const watchSalary = Form.useWatch("salaryGross", form);
    const watchBonus = Form.useWatch("bonusAndCommissions", form);
    const watchDividends = Form.useWatch("dividends", form);
    const watchInterest = Form.useWatch("interest", form);
    const watchRental = Form.useWatch("rentalIncome", form);
    const watchPartnership = Form.useWatch("generalLimitedPratnershipIncome", form);
    const watchTrust = Form.useWatch("trustIncome", form);
    const watchPension = Form.useWatch("pensionIncome", form);
    const watchOther = Form.useWatch("otherIncome", form);

    // 🧮 Auto-calculate total
    useEffect(() => {
        const toNumber = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        const total =
            toNumber(watchSalary) +
            toNumber(watchBonus) +
            toNumber(watchDividends) +
            toNumber(watchInterest) +
            toNumber(watchRental) +
            toNumber(watchPartnership) +
            toNumber(watchTrust) +
            toNumber(watchPension) +
            toNumber(watchOther);

        form.setFieldsValue({ total: total.toFixed(2) });
    }, [
        watchSalary,
        watchBonus,
        watchDividends,
        watchInterest,
        watchRental,
        watchPartnership,
        watchTrust,
        watchPension,
        watchOther,
        form,
    ]);

    const onFinish = async (values) => {

        if (values && parseFloat(values.total) <= 0) {
            message.error("Please enter an amount in at least one field (Total Income should not be 0)");
            return false;
        }

        setLoading(true);

        const reqObj = {
            ApplicationId: fromDashboard ? appObjId : localStorage.getItem("Id"),
            IsIncomesourceCompleted: true,
            CBRScore: values.creditBureauScore,
            listincomesource: [
                {
                    Id: 1,
                    ApplicationId: fromDashboard ? appObjId : localStorage.getItem("Id"),
                    GrossSalary: values.salaryGross,
                    BonusCommission: values.bonusAndCommissions,
                    Devidend: values.dividends,
                    Interest: values.interest,
                    RentalIncome: values.rentalIncome,
                    GenLimitedPartnershipIncome: values.generalLimitedPratnershipIncome,
                    TrustIncome: values.trustIncome,
                    PensionIncome: values.pensionIncome,
                    OtherIncome: values.otherIncome,
                    IncomeSourceTotal: values.total,
                }
            ]
        };
        try {
            const res = await _NewapplicationService.AddOrUpdateIncomeSource(reqObj);
            //  debugger
            if (res.data.IsSuccess) {
                //  debugger
                setLoading(false);
                message.success(res.data.Message);
                if (isFromDashboard) {
                    history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                }
                else {
                    history.push(routes.expenses.path);
                }
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            message.error(err.message || SUBMISSION_FAILED);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    let Id = localStorage.getItem("Id");

    const GetIncomeSourceByApplicationID = async () => {
        try {
            setLoading(true);
            const res = await _NewapplicationService.getIncomeSourceByApplicationID(isFromDashboard ? appObjId : Id);
            // debugger

            if (res.data && res.data.length > 0) {
                const item = res.data[0];
                const mappedItem = {
                    salaryGross: item.GrossSalary,
                    bonusAndCommissions: item.BonusCommission,
                    dividends: item.Devidend,
                    interest: item.Interest,
                    rentalIncome: item.RentalIncome,
                    generalLimitedPratnershipIncome: item.GenLimitedPartnershipIncome,
                    trustIncome: item.TrustIncome,
                    pensionIncome: item.PensionIncome,
                    otherIncome: item.OtherIncome,
                    total: item.IncomeSourceTotal,
                    Application_Status_Id: item.Application_Status_Id,
                    creditBureauScore: item.CBRScore,
                };
                setIncomeSource(mappedItem);
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } else {
            history.push(routes.uploaddocuments.path);
        }
    }

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                <div style={{
                    position: "absolute",
                    top: 5,
                    right: 20,
                    margin: 0,
                    zIndex: 1000,
                    maxWidth: "1000px",
                    padding: "8px 16px",
                }}>
                    <ApplicationProgressBar />
                    <Title level={3} style={{ margin: 0 }}>
                        <ShowApplicationId />
                    </Title>
                </div>
            )} */}
                <div>
                    {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                        <div>
                            <ApplicationProgressBar />
                            <Title level={5}>
                                {/* <ShowApplicationId /> */}
                            </Title>
                        </div>
                    )}
                </div>
                <div className="application-dark-page">
                    <div className="application-card">

                        <Row>
                            <Col span={24}>
                                <Title level={3} style={{ marginBottom: 25 }}> Income Sources </Title>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    initialValues={IncomeSource}
                                >
                                    <Form.Item
                                        label="Salary (Gross)"
                                        name="salaryGross"
                                        className='w50'
                                        rules={[{ required: false, message: "Salary (Gross) is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Salary (Gross)" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Bonus and Commissions"
                                        name="bonusAndCommissions"
                                        className='w50'
                                        rules={[{ required: false, message: "Bonus and Commissions is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Bonus and Commissions" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Dividends"
                                        name="dividends"
                                        className='w50'
                                        rules={[{ required: false, message: "Dividends is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Dividends" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Interest"
                                        name="interest"
                                        className='w50'
                                        rules={[{ required: false, message: "Interest is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Interest" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Rental Income (Net)"
                                        name="rentalIncome"
                                        className='w50'
                                        rules={[{ required: false, message: "Rental Income (Net) is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Rental Income (Net)" />
                                    </Form.Item>
                                    <Form.Item
                                        label="General Limited Partnership Income (Net)"
                                        name="generalLimitedPratnershipIncome"
                                        className='w50'
                                        rules={[{ required: false, message: "General Limited Partnership Income (Net) is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter General Limited Partnership Income (Net)" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Trust Income"
                                        name="trustIncome"
                                        className='w50'
                                        rules={[{ required: false, message: "Trust Income is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Trust Income" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Pension Income"
                                        name="pensionIncome"
                                        className='w50'
                                        rules={[{ required: false, message: "Pension Income is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Pension Income" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Other Income"
                                        name="otherIncome"
                                        className='w50'
                                        rules={[{ required: false, message: "Other Income is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Other Income" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Total"
                                        name="total"
                                        className='w50'
                                        rules={[{ required: false, message: "Total is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Total" disabled />
                                    </Form.Item>
                                    <Form.Item
                                        className='w50'
                                        label=" CBR Score"
                                        name="creditBureauScore"
                                        rules={[
                                            { required: true, message: "CBR Score is required" },
                                            {
                                                validator: (_, value) => {
                                                    // ⛔ don't check empty here
                                                    if (!value) return Promise.resolve();

                                                    const num = Number(value);

                                                    if (!Number.isInteger(num)) {
                                                        return Promise.reject(new Error("Enter a valid integer"));
                                                    }

                                                    if (num < 300 || num > 850) {
                                                        return Promise.reject(
                                                            new Error("CBR Score must be between 300 and 850")
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <IntegerInput
                                            maxLength={3}
                                            placeholder="Enter CBR Score"

                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: "20px" }} className="w95">
                                            <ButtonComponent
                                                text="Go Back"
                                                onClick={onBack}
                                                type="default"
                                            />
                                            <ButtonComponent
                                                text={
                                                    <span>
                                                        Save And Proceed <ArrowRightOutlined />
                                                    </span>
                                                }
                                                htmlType="submit"
                                                type="primary"
                                                disabled={!(
                                                    Object.keys(IncomeSource || {}).length === 0 ||
                                                    [1,2,4,9].includes(IncomeSource?.Application_Status_Id)
                                                )}
                                            />


                                        </div>
                                    </Form.Item>

                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default IncomeSources;